import type { LucideIcon } from 'lucide-react'
import * as React from 'react'
import { forwardRef } from 'react'

export const ContentIcon: LucideIcon = forwardRef(({ size = 24, color = 'white', ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_3_11541)'>
        <path
          d='M6.55379 6.49817C6.55379 5.48357 7.36017 4.66178 8.35577 4.66178H19.01V3.70227C19.01 3.19726 18.6045 2.78408 18.109 2.78408H5.89156C5.39602 2.78408 4.99057 3.19726 4.99057 3.70227V19.9543C4.99057 20.4593 5.39602 20.8725 5.89156 20.8725H6.55379V6.49817Z'
          fill={color}
        />
        <path
          d='M14.9102 19.8759C14.2344 19.8759 13.6848 20.4957 13.6848 21.2578H16.1355C16.1355 20.4957 15.5859 19.8759 14.9102 19.8759Z'
          fill={color}
        />
        <path
          d='M8.80597 6.0387C8.31043 6.0387 7.90499 6.45189 7.90499 6.9569V23.2089C7.90499 23.7139 8.31043 24.1271 8.80597 24.1271H21.0234C21.5189 24.1271 21.9244 23.7139 21.9244 23.2089V6.9569C21.9244 6.45189 21.5189 6.0387 21.0234 6.0387H8.80597ZM10.5584 18.0349C10.0629 18.0349 9.66191 17.6263 9.66191 17.1213C9.66191 16.6163 10.0629 16.2077 10.5584 16.2077C11.0539 16.2077 11.4549 16.6163 11.4549 17.1213C11.4549 17.6263 11.0539 18.0349 10.5584 18.0349ZM14.9102 22.2448C13.4371 22.2448 12.2117 21.0328 11.982 19.4443C11.9414 19.1597 12.1486 18.9026 12.4279 18.9026H17.3969C17.6762 18.9026 17.8834 19.1597 17.8429 19.4443C17.6131 21.0328 16.3878 22.2448 14.9147 22.2448H14.9102ZM19.2619 18.0349C18.7664 18.0349 18.3655 17.6263 18.3655 17.1213C18.3655 16.6163 18.7664 16.2077 19.2619 16.2077C19.7575 16.2077 20.1584 16.6163 20.1584 17.1213C20.1584 17.6263 19.7575 18.0349 19.2619 18.0349Z'
          fill={color}
        />
        <path
          d='M15.194 -0.127106H2.97661C2.48107 -0.127106 2.07562 0.286082 2.07562 0.791089V17.0431C2.07562 17.5481 2.48107 17.9613 2.97661 17.9613H3.63884V3.24267C3.63884 2.22806 4.44522 1.40628 5.44081 1.40628H16.095V0.791089C16.095 0.286082 15.6896 -0.127106 15.194 -0.127106Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_3_11541'>
          <rect width={24} height={24} fill={color} />
        </clipPath>
      </defs>
    </svg>
  )
})

ContentIcon.displayName = 'ContentIcon'
